module.exports = __webpack_public_path__ + "static/media/emojis_17.c7db6883.svg";